import React from 'react';
export function FooterCTA() {
  return <section className="bg-[#0F172A] py-20 px-5 text-center border-t-[3px] border-[#F97316]" data-id="element-40">
      <div className="max-w-[780px] mx-auto" data-id="element-41">
        <div className="w-12 h-1 bg-gradient-to-r from-[#15803D] to-[#22C55E] rounded-sm mx-auto mb-5" data-id="element-42" />

        <h2 className="font-montserrat text-[clamp(22px,3.5vw,32px)] font-extrabold text-center mb-[10px] text-white tracking-tight leading-[1.2]" data-id="element-43">
          ¿Seguís pagando $3.500 por barrita?
        </h2>

        <p className="text-[#94A3B8] text-base mb-7" data-id="element-44">
          O invertís $16.990 una sola vez y fabricás miles por el resto de tu
          vida.
        </p>

        <a href="#comprar" className="inline-block bg-[#F97316] text-white font-montserrat text-[15px] font-extrabold uppercase tracking-[1.5px] py-[18px] px-11 rounded-lg border-none cursor-pointer no-underline transition-all duration-[0.25s] hover:bg-[#C2410C] hover:shadow-[0_8px_32px_rgba(249,115,22,0.45)] hover:-translate-y-0.5 active:translate-y-0" style={{
        animation: 'pulse-cta 2.5s ease infinite'
      }} data-id="element-45">
          SÍ, QUIERO EL MÉTODO BARRITA PRO &gt;&gt;
        </a>

        <p className="text-xs text-[#475569] mt-[14px] tracking-[0.5px]" data-id="element-46">
          🔒 Pago seguro · Acceso inmediato · Garantía 7 días sin preguntas
        </p>
      </div>
    </section>;
}